export default {
  siteData: (state) => state.siteInfo.siteData,
  sizeFonts: (state) => state.setFont.sizeFonts,
  // 四大对象相关
  commonInfo: (state) => state.examination.commonInfo,
  quesTypeShowMap: (state) => state.examination.quesTypeShowMap,
  quesShowList: (state) => state.examination.quesShowList,
  userAnsMap: (state) => state.examination.userAnsMap,
  submitData: (state) => state.examination.submitData,
  questions: (state) => state.examination.questions,
  // 当前题目相关
  currentQuestion: (state) => state.examination.currentQuestion,
  currentQuestionType: (state) => state.examination.currentQuestionType,
  currentQuestionIndex: (state) => state.examination.currentQuestionIndex
};
